import { createNode } from '@glueapp/graph-types';

export const ToUpperCase = createNode({
    id: 'To Upper Case',
    name: 'To Upper Case',
    description: 'Changes all characters in a text to their uppercase equivalent',
    aiDescription: 'Converts a string to uppercase. Connect a string to "Input"; outputs the uppercased string on "Output".',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {
        Input: {
            kind: 'string',
        },
    },
    outPorts: {
        Output: {
            kind: 'string',
        },
    },
    execute: function (input) {
        return { output: { Output: input.inPorts.Input.toUpperCase() } };
    },
});
